// Icone padrao de acoes do sistema (emseg-icones-sistema/icons/acoes.svg).
export default function IconAcoes({ size = 16, style, ...props }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      role="img" aria-label="Ações" style={{ display: 'block', ...style }} {...props}>
      <path d="M5 7h14M5 12h14M5 17h14" />
    </svg>
  )
}
